export const CONFIRM_FORGOT_PASSWORD = 'CONFIRM_FORGOT_PASSWORD'
export const UPDATE_RESET_PASSWORD_FIELD = 'UPDATE_RESET_PASSWORD_FIELD'
export const SET_RESET_PASSWORD_USERNAME = 'SET_RESET_PASSWORD_USERNAME'

export const FIRST_LOGIN = 'FIRST_LOGIN'
export const ALREADY_CONFIRMED_USER = 'ALREADY_CONFIRMED_USER'

export const SERVER_RESOURCE = '/users/oauth/login'



// WEBPACK FOOTER //
// ./src/pages/reset-password/constants.ts